function getContextPath(host = window.location.href) {
  let context_path;
  if (
    host !== undefined &&
    host.includes(process.env.REACT_APP_AKAMAI_IMMUNIZATION_URL)
  ) {
    context_path = process.env.REACT_APP_AKAMAI_IMMUNIZATION_URL;
  } else if (
    host !== undefined &&
    host.includes(process.env.REACT_APP_AKAMAI_PRESCRIPTION_URL)
  ) {
    context_path = process.env.REACT_APP_AKAMAI_PRESCRIPTION_URL;
  } else {
    context_path = process.env.REACT_APP_CONTEXT_PATH;
  }
  return context_path;
}
export default getContextPath;
